(function () {
  'use strict';

  if (!window.PET_PROFILE_WORKER_URL) {
    var host = window.location.hostname;
    if (host === '127.0.0.1' || host === 'localhost') {
      window.PET_PROFILE_WORKER_URL = 'http://127.0.0.1:8787';
    }
  }

  var WORKER_BASE = (window.PET_PROFILE_WORKER_URL || 'https://recommender-api-production.upahar.workers.dev').replace(/\/$/, '');
  var BREEDS_DATA_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cdn/shop/files/product-recommender-data.json';
  var BREEDS_FALLBACK_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'assets/product-recommender-data.json';
  var RETRY_KEY = 'pet_profile_sync_queue';
  var MAX_RETRY_QUEUE = 20;
  var MAX_PETS = 6;

  var state = {
    pets: [defaultPet()],
    breeds: [],
    submitting: false,
    done: false,
  };

  function defaultPet() {
    return { name: '', breed: '', age_value: '', age_unit: 'years', weight_kg: '', gender: '' };
  }

  function track(event, data) {
    if (window.MinimogTheme && typeof window.MinimogTheme.trackEvent === 'function') {
      try { window.MinimogTheme.trackEvent(event, data || {}); } catch (e) {}
    }
    if (window.dataLayer && window.dataLayer.push) {
      window.dataLayer.push({ event: event, ...(data || {}) });
    }
  }

  function readAuthFromContext() {
    var params = new URLSearchParams(window.location.search);
    var hmacToken = params.get('t') || params.get('token');
    if (hmacToken) return { mode: 'email', hmac_token: hmacToken };

    var thankYou = window.PET_PROFILE_THANKYOU;
    if (thankYou && thankYou.order_id && thankYou.checkout_token && thankYou.email) {
      return {
        mode: 'thankyou',
        order_id: thankYou.order_id,
        checkout_token: thankYou.checkout_token,
        email: thankYou.email,
      };
    }
    return null;
  }

  function loadBreeds() {
    return fetch(BREEDS_DATA_URL).then(function (r) {
      if (r.ok) return r.json();
      return fetch(BREEDS_FALLBACK_URL).then(function (r2) { return r2.json(); });
    }).then(function (data) {
      var breeds = data && data.breeds ? Object.keys(data.breeds) : [];
      state.breeds = breeds.map(function (k) {
        return { id: k, label: k.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }) };
      });
    }).catch(function () { state.breeds = []; });
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === 'className') node.className = v;
      else if (k === 'onClick') node.addEventListener('click', v);
      else if (k === 'onInput') node.addEventListener('input', v);
      else if (k === 'onChange') node.addEventListener('change', v);
      else if (k === 'onSubmit') node.addEventListener('submit', v);
      else node.setAttribute(k, v);
    });
    (children || []).forEach(function (c) {
      if (c == null || c === false) return;
      node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return node;
  }

  function render(root) {
    root.innerHTML = '';
    root.classList.add('pet-profile');

    if (state.done) {
      root.appendChild(renderSuccess());
      return;
    }

    var form = el('form', { className: 'pet-profile__form', onSubmit: handleSubmit, novalidate: 'novalidate' }, [
      el('h3', { className: 'pet-profile__title' }, ['Tell us about your pet']),
      el('p', { className: 'pet-profile__subtitle' }, ['We\'ll use this to tailor your care tips — and send you a mystery gift 🎁']),
      renderPets(),
      state.pets.length < MAX_PETS ? el('button', {
        type: 'button',
        className: 'pet-profile__add',
        onClick: handleAddPet,
      }, ['+ Add another pet']) : null,
      el('button', {
        type: 'submit',
        className: 'pet-profile__submit',
        disabled: state.submitting ? 'disabled' : null,
      }, [state.submitting ? 'Saving…' : 'Claim my mystery gift']),
      state.error ? el('div', { className: 'pet-profile__error', role: 'alert' }, [state.error]) : null,
    ]);

    root.appendChild(form);
  }

  function renderPets() {
    var wrap = el('div', { className: 'pet-profile__pets' }, []);
    state.pets.forEach(function (p, idx) {
      wrap.appendChild(renderPetCard(p, idx));
    });
    return wrap;
  }

  function renderPetCard(pet, idx) {
    var card = el('fieldset', { className: 'pet-profile__card' }, []);
    if (state.pets.length > 1) {
      card.appendChild(el('legend', { className: 'pet-profile__legend' }, ['Pet ' + (idx + 1)]));
      card.appendChild(el('button', {
        type: 'button',
        className: 'pet-profile__remove',
        'aria-label': 'Remove pet ' + (idx + 1),
        onClick: function () { handleRemovePet(idx); },
      }, ['×']));
    }

    card.appendChild(field('Pet\'s name', el('input', {
      type: 'text', required: 'required', maxlength: '40',
      value: pet.name, autocomplete: 'off',
      onInput: function (e) { pet.name = e.target.value; },
    })));

    card.appendChild(field('Breed', breedInput(pet)));

    card.appendChild(field('Age', ageInput(pet)));

    card.appendChild(field('Weight (kg)', el('input', {
      type: 'number', min: '0.1', max: '150', step: '0.1', required: 'required',
      value: pet.weight_kg,
      onInput: function (e) { pet.weight_kg = e.target.value; },
    })));

    card.appendChild(field('Gender', genderInput(pet, idx)));
    return card;
  }

  function field(label, input) {
    var id = 'pp-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('id', id);
    return el('label', { className: 'pet-profile__field', for: id }, [
      el('span', { className: 'pet-profile__label' }, [label]),
      input,
    ]);
  }

  function breedInput(pet) {
    var listId = 'breeds-' + Math.random().toString(36).slice(2, 8);
    var input = el('input', {
      type: 'text', required: 'required', maxlength: '50', list: listId,
      placeholder: 'Start typing…', autocomplete: 'off',
      value: pet.breed,
      onInput: function (e) { pet.breed = e.target.value; },
    });
    var datalist = el('datalist', { id: listId }, state.breeds.map(function (b) {
      return el('option', { value: b.label });
    }));
    var wrap = el('div', { className: 'pet-profile__breed' }, [input, datalist]);
    return wrap;
  }

  function ageInput(pet) {
    var number = el('input', {
      type: 'number', min: '0', max: '30', step: '1', required: 'required',
      value: pet.age_value,
      onInput: function (e) { pet.age_value = e.target.value; },
    });
    var unit = el('select', {
      onChange: function (e) { pet.age_unit = e.target.value; },
    }, [
      el('option', { value: 'years' }, ['years']),
      el('option', { value: 'months' }, ['months']),
    ]);
    unit.value = pet.age_unit;
    return el('div', { className: 'pet-profile__age' }, [number, unit]);
  }

  function genderInput(pet, idx) {
    var name = 'gender-' + idx + '-' + Math.random().toString(36).slice(2, 6);
    function opt(val, label) {
      var input = el('input', {
        type: 'radio', name: name, value: val, required: 'required',
        onChange: function (e) { pet.gender = e.target.value; },
      });
      if (pet.gender === val) input.setAttribute('checked', 'checked');
      return el('label', { className: 'pet-profile__radio' }, [input, el('span', {}, [label])]);
    }
    return el('div', { className: 'pet-profile__genders' }, [opt('male', 'Male'), opt('female', 'Female')]);
  }

  function renderSuccess() {
    return el('div', { className: 'pet-profile__success' }, [
      el('div', { className: 'pet-profile__success-emoji', 'aria-hidden': 'true' }, ['🎁']),
      el('h3', { className: 'pet-profile__title' }, ['All set!']),
      el('p', {}, ['Your mystery gift will arrive soon. In the meantime, enjoy care tips tailored for your pack.']),
    ]);
  }

  function handleAddPet() {
    if (state.pets.length >= MAX_PETS) return;
    state.pets.push(defaultPet());
    track('pet_profile_pet_added', { pet_count: state.pets.length });
    rerender();
  }

  function handleRemovePet(idx) {
    state.pets.splice(idx, 1);
    if (state.pets.length === 0) state.pets.push(defaultPet());
    rerender();
  }

  function normalizePets() {
    var known = {};
    state.breeds.forEach(function (b) { known[b.label.toLowerCase()] = b.id; });
    return state.pets.map(function (p) {
      var ageMonths = Number(p.age_value) * (p.age_unit === 'years' ? 12 : 1);
      var breedLabel = (p.breed || '').trim();
      var knownId = known[breedLabel.toLowerCase()];
      return {
        name: (p.name || '').trim(),
        breed: knownId || breedLabel,
        breed_custom: !knownId,
        age_months: Math.round(ageMonths),
        weight_kg: Number(p.weight_kg),
        gender: p.gender,
      };
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (state.submitting) return;

    var auth = readAuthFromContext();
    if (!auth) {
      state.error = 'Session expired. Please try the link from your email again.';
      rerender();
      return;
    }

    var pets = normalizePets();
    for (var i = 0; i < pets.length; i++) {
      if (!pets[i].name || !pets[i].breed || !pets[i].gender || !pets[i].weight_kg || !pets[i].age_months) {
        state.error = 'Please fill all fields for each pet.';
        rerender();
        return;
      }
    }

    state.submitting = true;
    state.error = null;
    rerender();

    var payload = {
      source: auth.mode,
      pets: pets,
      ...(auth.mode === 'email'
        ? { hmac_token: auth.hmac_token }
        : { order_id: auth.order_id, checkout_token: auth.checkout_token, email: auth.email }),
    };

    submit(payload).then(function (res) {
      state.submitting = false;
      state.done = true;
      track('pet_profile_submitted', {
        pet_count: pets.length,
        breeds: pets.map(function (p) { return p.breed; }),
        has_custom_breed: pets.some(function (p) { return p.breed_custom; }),
        source: auth.mode,
      });
      rerender();
    }).catch(function (err) {
      state.submitting = false;
      if (err && err.offline) {
        state.done = true;
        state.error = null;
      } else {
        state.error = (err && err.message) || 'Something went wrong. Please try again.';
      }
      track('pet_profile_submit_failed', { error: err && err.message, status: err && err.status, source: auth.mode });
      rerender();
    });
  }

  function submit(payload) {
    return fetch(WORKER_BASE + '/pet-profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-By': 'pet-profile-form',
      },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors',
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (!r.ok) {
          var httpErr = new Error((body && body.error) || ('HTTP ' + r.status));
          httpErr.status = r.status;
          throw httpErr;
        }
        return body;
      });
    }, function (networkErr) {
      queueForRetry(payload);
      var offlineErr = new Error(networkErr.message);
      offlineErr.offline = true;
      throw offlineErr;
    });
  }

  function queueForRetry(payload) {
    try {
      var queue = JSON.parse(localStorage.getItem(RETRY_KEY) || '[]');
      queue.push({ payload: payload, ts: Date.now() });
      localStorage.setItem(RETRY_KEY, JSON.stringify(queue.slice(-MAX_RETRY_QUEUE)));
    } catch (e) {}
  }

  var RETRY_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

  function drainRetryQueue() {
    try {
      var raw = JSON.parse(localStorage.getItem(RETRY_KEY) || '[]');
      var cutoff = Date.now() - RETRY_MAX_AGE_MS;
      var queue = raw.filter(function (e) { return e && e.ts && e.ts > cutoff; });
      if (queue.length !== raw.length) {
        localStorage.setItem(RETRY_KEY, JSON.stringify(queue));
      }
      if (!queue.length) return;
      var remaining = [];
      var done = 0;
      queue.forEach(function (entry) {
        fetch(WORKER_BASE + '/pet-profile', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-By': 'pet-profile-form' },
          body: JSON.stringify(entry.payload),
          credentials: 'omit',
          mode: 'cors',
        }).then(function (r) {
          if (!r.ok) remaining.push(entry);
          done++;
          if (done === queue.length) localStorage.setItem(RETRY_KEY, JSON.stringify(remaining));
        }).catch(function () {
          remaining.push(entry);
          done++;
          if (done === queue.length) localStorage.setItem(RETRY_KEY, JSON.stringify(remaining));
        });
      });
    } catch (e) {}
  }

  var rootRef = null;
  function rerender() { if (rootRef) render(rootRef); }

  function mount(root) {
    rootRef = root;
    var auth = readAuthFromContext();
    track('pet_profile_started', { source: (auth && auth.mode) || 'unknown' });
    loadBreeds().then(function () { rerender(); });
    render(root);
    drainRetryQueue();
  }

  function init() {
    var roots = document.querySelectorAll('[data-pet-profile-root]');
    roots.forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MinimogTheme = window.MinimogTheme || {};
  window.MinimogTheme.PetProfile = { mount: mount, drainRetryQueue: drainRetryQueue };
})();
